import { render, staticRenderFns } from "./TakeSnapshot.vue?vue&type=template&id=87330f28&scoped=true&"
import script from "./TakeSnapshot.vue?vue&type=script&lang=js&"
export * from "./TakeSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./TakeSnapshot.vue?vue&type=style&index=0&id=87330f28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87330f28",
  null
  
)

export default component.exports